import { render, staticRenderFns } from "./userDataLimits.vue?vue&type=template&id=3e65b0aa&scoped=true"
import script from "./userDataLimits.vue?vue&type=script&lang=js"
export * from "./userDataLimits.vue?vue&type=script&lang=js"
import style0 from "./userDataLimits.vue?vue&type=style&index=0&id=3e65b0aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e65b0aa",
  null
  
)

export default component.exports